import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";
import {toast} from "react-toastify";

const GetInitialData = async (setInitialData, setIsLoad, myLocation, setSendData, sendData) => {
  const productsData = await _axios.get(prefixUrl() + "/discountCampaign/?request=productsData")
  if (productsData?.data?.status) {
    setInitialData(productsData.data.data);
    setIsLoad(true);
  } else {
    toast.error(productsData?.data?.message)
  }

  if (myLocation?.state?.id) {
    const editData = await _axios.get(prefixUrl() + "/discountCampaign/?request=campaignSubmittedData&campaignId=" + myLocation?.state?.id);
    if (editData?.data?.status) {
      setSendData({...sendData, ...editData?.data?.data, campaignId: myLocation?.state?.id})
    } else {
      toast.error(productsData?.data?.message)
    }
  }
};

export default GetInitialData;